// 項目設置模塊
export default {
    SetUp: {
        AnswerSet: '答題設置',
        QualitySettings: '質量設置',
        PublicSettings: '公開設置',
        OtherSettings: '其他設置',
        CanOnly: '只能',
        EveryHour: '每小時',
        EveryDay: '每天',
        Weekly: '每周',
        Monthly: '每月',
        Thanking: '您的答卷已提交，感謝您的參與！',
        OnlyWeChatAnswerQuestions: '只允許微信答題',
        WeChatRestrictions: '每個微信答題次數限制',
        PleaseSelect: '請選擇',
        Answer: '答題',
        PleaseEnterContent: '請輸入內容',
        Times: '次',
        ComputerOrPhoneRestrictions: '每臺電腦或手機答題次數限制',
        IPRestrictions: '每個IP答題次數限制',
        ActivateAccessPassword: '啟動訪問密碼',
        EnterTheAccessPassword: '請輸入訪問密碼',
        MailOnly: '只有郵件邀請的受訪者可回答',
        SetTime: '設置開始/結束時間',
        SetStartTime: '設置開始時間',
        NoRestrictions: '沒有限制',
        SetEndTime: '設置結束時間',
        EndTimeGreaterThanStartTime: '結束時間需要大於開始時間',
        SetDataUpperLimit: '設定答題數據上限',
        Collect: '收集',
        EndOfData: '份數據時結束',
        ControlPageFillingTime: '控制頁面填寫時間',
        Limitation: '限制',
        TimedOutAutomaticSubmission: '分鐘內完成問卷 , 超時將所有內容自動提交',
        SetQuotas: '設置配額',
        PublicSettings: '公開設置',
        ShareButton: '顯示“分享”按鈕，可分享鏈接至更多社交網站(僅電腦答題頁)',
        AnswerSquare: '是否發布到答題廣場',
        OtherSettings: '其他設置',
        CustomJump: '答題完成後自定義跳轉',
        SettableVariables: '可設置變量，舉例',
        QuestionnaireIdentification: '問卷標識',
        UserId: '用戶ID，僅對登錄答題有效',
        ThirdParty: '第三方對接系統ID，僅對對接答題有效',
        UniqueId: '每個答題者唯一ID"',
        Staging: '開啟答卷暫存',
        ThirdPartyTitle: '第三方接口對接設置',
        SatisfactionScore: '是否啟用滿意度得分匯總',
        TotalScoreFormula: '總分公式',
        RandomSettings: '隨機設置',
        DockingSettings: '對接設置',
        IsTheQuestionnaireValid: '問卷是否有效',
        SetEffectiveTime: '設置有效時間(天)',
        SynchronizeSamples: '同步樣本參數設置',
        RuleSettings: '問卷規則設置',
        SampleParameters: '樣本參數設置',
        Add: '添加',
        FieldName: '字段名稱',
        EnglishName: '字段英文名稱',
        Close: '關 閉',
        PleaseEnterAFieldName: '請輸入字段名稱',
        PleaseEnterAnEnglishName: '請輸入字段英文名稱',
        ReturnVisitChannels: '回訪渠道',
        FollowUpType: '回訪類型',
        ValidOrNot: '是否有效',
        DeleteIt: '確定刪除嗎？',
        AddRuleSettings: '添加問卷規則設置',
        RuleType: '規則類型',
        SelectARuleType: '請選擇規則類型',
        RuleChannel: '規則渠道',
        SelectARuleChannel: '請選擇規則渠道',
        EditQuestionnaireRuleSettings: '編輯問卷規則設置',
        NameOfFollowUpVisit: '回訪名稱',
        RuleName: '規則名稱',
        ModifyQuestionnaireRules: '修改問卷規則設置',
        WeChatSettings: '微信設置',
        QuerySettings: '查詢設置',
        SampleSettings: '樣本設置',
        PrizesAndRedEnvelopes: '獎品與紅包',
        JumpToTheSpecifiedPage: '跳轉到指定頁面 (例 http://www.baidu.com)',
        PleaseEnterTheAddress: '請輸入地址',
        PleaseSelectWhetherItIsValid: '請選擇是否有效',
        DoNotSet: '不設置',
        RandomizeByQuestion: '按題目隨機',
        RandomByPage: '按分頁隨機',
        PiecewiseRandom: '分段隨機',
        NewlyAdded: '新增',
        StartingQuestion: '從開始題',
        StartNum: '題號不得小於1並且大於總題數',
        ToTheEndQuestion: '到結束題',
        EndNum: '題號不得小於1並且大於總題數',
        Randomizing: '隨機抽取',
        TheCurrentRangeOnlyHas:'當前範圍只有',
        Questions: '道題',
        Question: '題',
        FromStartPage: '從開始頁',
        pageStartNum: '頁碼不得小於1並且大於總頁數',
        ToEndPage: '到結束頁',
        PageEndNum: '頁碼不得小於1並且大於總頁數',
        Page: '第',
        Pages: '頁',
        NumberOfQuestions: '題目數',
        ShowOnlySomeTitlesOnThisPage: '只顯示此頁部分題目',
        RandomFunction: '隨機功能',
        RemoveObstaclesFrom: '開通',
        TheCurrentPageHas: '當前頁有',
        Tip: '提示',
        CheckOn: '如果問卷中包含“邏輯設置”“關聯邏輯”“引用邏輯”，設置隨機抽題後可能會導致這些邏輯失效，請檢查！',
        MoreThanTwoQuestions: '問卷題目超過兩題以上才能選擇此項',
        GotIt: '知道了',
        OverTwoPages: '問卷頁數超過兩頁以上才能選擇此項',
        Yes: '是',
        No: '否',
    },
  };